import React from 'react'



import TermsConditions from '../Privacyandterms/TermsConditions'
import Navbar from '../Navbar/Navbar'
import Footer from '../Home/Footer'

const Termspage = () => {
  return (
    <div>
        <Navbar/>
        <TermsConditions/>

        <Footer/>
    </div>
  )
}

export default Termspage